module.exports = __webpack_public_path__ + "static/img-woman-working@3x.86ab3cb8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/img-woman-working@3x.jpg
// module id = 805
// module chunks = 199482085584678